import { render, staticRenderFns } from "./oneShuttle.vue?vue&type=template&id=2707ccd6&scoped=true&"
import script from "./oneShuttle.vue?vue&type=script&lang=js&"
export * from "./oneShuttle.vue?vue&type=script&lang=js&"
import style0 from "./oneShuttle.vue?vue&type=style&index=0&id=2707ccd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707ccd6",
  null
  
)

export default component.exports